exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-47c23b2b]{margin-top:0;margin-bottom:0}", ""]);

// exports
